import React from "react";
import { LandTourDetail } from "../../../../interfaces/land-tour.interface";

const ICONS = "/iceholidays-assets/images/icons";

interface Item {
  icon: string;
  label: string;
}

interface Props {
  landTour: LandTourDetail;
}

// 3-column "What's Included" grid. Column split follows the Figma layout
// exactly; items only render when the backing field is truthy.
export default function WhatsIncluded({ landTour }: Props) {
  const columns: Item[][] = [
    [
      landTour.guideLanguages ? { icon: "globe", label: `Tour Guide: ${landTour.guideLanguages}` } : null,
      landTour.incHalfBoardMeals ? { icon: "meal", label: "Half Board Meal(s) Included" } : null,
      landTour.incTransportation ? { icon: "transport", label: "Transportation Included" } : null,
      landTour.tipping ? { icon: "cash", label: `Tipping ${landTour.tipping}` } : null,
    ].filter(Boolean) as Item[],
    [
      landTour.freeOfCharge ? { icon: "foc", label: `${landTour.freeOfCharge} FOC` } : null,
      landTour.incHotel ? { icon: "hotel", label: "Hotel(s) Included" } : null,
      landTour.incFullBoardMeals ? { icon: "meal", label: "Full Board Meal(s) Included" } : null,
      landTour.incShoppingStop ? { icon: "shopping", label: "Shopping Stop Included" } : null,
    ].filter(Boolean) as Item[],
    [
      landTour.depositText ? { icon: "cash", label: `Deposit: ${landTour.depositText}` } : null,
      landTour.incFlight ? { icon: "flight", label: "Flight(s) Included" } : null,
      landTour.incEntranceTicket ? { icon: "ticket", label: "Entrance Ticket(s) Included" } : null,
      landTour.incInstantConfirmation ? { icon: "flash", label: "Instant Confirmation" } : null,
    ].filter(Boolean) as Item[],
  ];

  if (columns.every((column) => column.length === 0)) return null;

  return (
    <section className="ground-tour-show-v2__included">
      <img
        className="ground-tour-show-v2__included-decoration"
        src={`${ICONS}/included-card-decoration.png`}
        alt=""
        aria-hidden="true"
      />

      <h2 className="ground-tour-show-v2__included-title">What's Included</h2>

      <div className="ground-tour-show-v2__included-grid">
        {columns.map((column, columnIndex) => (
          <div className="ground-tour-show-v2__included-column" key={columnIndex}>
            {column.map((item, itemIndex) => (
              <div className="ground-tour-show-v2__included-item" key={itemIndex}>
                {/* Masked with the brand red rather than shipping recolored asset copies. */}
                <span
                  className="ground-tour-show-v2__included-icon"
                  style={{
                    WebkitMaskImage: `url(${ICONS}/icon-included-${item.icon}.png)`,
                    maskImage: `url(${ICONS}/icon-included-${item.icon}.png)`,
                  }}
                  aria-hidden="true"
                />
                <span>{item.label}</span>
              </div>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
